export enum NotificationType {
    Info,
    Alert,
    News
}

export function notificationTypeToString(type: NotificationType): string {
    switch (type) {
        case NotificationType.Info:
            return "Info";
        case NotificationType.Alert:
            return "Upozorenje";
        case NotificationType.News:
            return "Novo";
        default:
            return "Unknown";
    }
}